import React, { Component } from "react";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import FormControl from "@material-ui/core/FormControl";
import TextField from '@material-ui/core/TextField';
import CustomInput from "components/CustomInput/CustomInput.jsx";
import PictureUpload from "components/CustomUpload/ImageUpload.jsx";
import Button from "components/CustomButtons/Button.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import DatePicker from "react-datepicker";
import NotifList from "granular/Notification/notifList.js";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Select from '@material-ui/core/Select';
import { fetchPeopleAll, deletePeople, pushPeople, updatePeople } from "../../api/people";
import MenuItem from '@material-ui/core/MenuItem';
import moment from "moment";
import PeopleList from "../../granular/People/peopleList";
import { connect } from "react-redux";
import { pushLoader } from "../../actions/main";
import "react-datepicker/dist/react-datepicker.css";
import { withRouter } from "react-router-dom";

class People extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      name: '',
      email: '',
      brithday: '',
      password: '',
      gender: "male",
      login_type: "web",
      picture_background_url: "",
      picture_url: "",
      social_id: "",
      description: "-",
      job: "-",
      company_code: "",
      datatable: [],
      openAdd: false,
      openEdit: false,
      userlevel: 0,
      brithdayex: ''
    };
  }

    componentDidMount(){
        this.getDatatable()
    }

    handleSubmit = () => {
        if(this.state.brithday === ""){
            this.setState({
                errorBirth: true
            })
        }else{
            pushPeople(this.state)
            .then(response => {
                if (response != null) {
                    this.setState({
                        name: '',
                        email: '',
                        brithday: '',
                        password: '',
                        gender: "male",
                        login_type: "web",
                        picture_background_url: "",
                        picture_url: "",
                        social_id: "",
                        description: "-",
                        job: "-",
                        company_code: "",
                        openAdd: false,
                        errorBirth: false
                    })
                    this.getDatatable();
                }
            })
            .catch(error => {
                this.props.history.push("/pages/login#logout");
            })
        }

    }

    handleUpdate = () => {
        updatePeople(this.state)
        .then(response => {
            if (response != null) {
                this.setState({
                    name: '',
                    email: '',
                    brithday: '1970-01-01',
                    gender: "male",
                    login_type: "web",
                    picture_background_url: "",
                    picture_url: "",
                    password: '',
                    social_id: "",
                    description: "-",
                    job: "-",
                    company_code: "",
                    errorBirth: false,
                    openEdit: false,
                    userlevel: 0
                })
                this.getDatatable();
            }
        })
        .catch(error => {
            this.props.history.push("/pages/login#logout");
        })
    }

    getDatatable = () => {
        this.props.pushLoader(true);
        fetchPeopleAll()
        .then(response => {
            if (response != null) {

                this.setState({ datatable: response.data.results });
            }
            this.props.pushLoader(false);
        })
        .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
        });
    }

    handleChangeText = (keys,e) => {
        this.setState({ [keys]: e.target.value });
    };

    handleDelete = (id) => {
        deletePeople(id)
            .then(response => {
            if (response != null) {
                this.getDatatable();
            }
        })
        .catch(error => {
            console.log("tidak berhasil");
            this.props.history.push("/pages/login#logout");
        });
    }

    restate = (args) => {
        console.log(args[3]);
        if(args[3]===null){
          args[3] = '1970-01-01';
        }
        console.log(args)
        this.setState({
            id: args[0],
            name: args[2],
            email: args[1],
            brithday: args[3],
            gender: args[4],
            login_type: "web",
            picture_background_url: "",
            picture_url: "",
            social_id: "",
            description: args[5],
            job: args[6],
            company_code: args[7],
            openEdit: true
        })
    }

    handleClose = (key,value) =>{

      if(key === "openEdit"){
        this.setState({  brithday: '1970-01-01' });
      }else{
        this.setState({  brithday: '' });
      }
      this.setState({
          name: '',
          email: '',
          password: '',
          gender: "male",
          login_type: "web",
          picture_background_url: "",
          picture_url: "",
          social_id: "",
          description: "-",
          job: "-",
          company_code: "",
          openAdd: false,
          errorBirth: false
      })
        this.setState({
          [key]: value
        })
    }

    handleChangePicture = (e) => {
        this.setState({picture_url:e})
    }

    handleChangeBackground = (e) => {
        this.setState({picture_background_url:e})
    }

    handleChangedateNotif = event => {
      console.log(event);

      let dd = moment(event).toDate();
      console.log(dd);
        //console.log(moment(event._d).format("YYYY-MM-DD kk:mm:ss"));
      this.setState({ brithday: event });
    };

    render(){
        return(

            <GridContainer>

                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="rose" icon>
                            <Button color="primary" onClick={() => this.handleClose("openAdd", true)}>
                                Add User
                            </Button>
                        </CardHeader>
                        <PeopleList
                            datatable={this.state.datatable}
                            handleDelete={this.handleDelete}
                            restate={this.restate}
                        />
                    </Card>
                    <Dialog fullScreen open={this.state.openAdd} onClose={() => this.handleClose("openAdd", false)} aria-labelledby="form-dialog-title">
                        <DialogTitle id="form-dialog-title">Add User</DialogTitle>
                        <DialogContent>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={12}>
                                    <CustomInput
                                        labelText="Name"
                                        id="headerText"

                                        inputProps={{
                                            value: this.state.name,
                                            onChange:(e) => this.handleChangeText("name",e)
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <CustomInput
                                        labelText="Email"
                                        id="headerText"

                                        inputProps={{
                                            value: this.state.email,
                                            onChange:(e) => this.handleChangeText("email",e)
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <CustomInput
                                        labelText="Password"
                                        id="headerText"
                                        inputProps={{
                                            value: this.state.password,
                                            type: "password",
                                            onChange:(e) => this.handleChangeText("password",e)
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <InputLabel>Birthday</InputLabel>
                                    <br />
                                    <FormControl fullWidth>
                                    <DatePicker
                                      selected={this.state.brithday}
                                      dateFormat="yyyy-MM-dd"
                                      onChange={date => this.handleChangedateNotif(date)}
                                      peekNextMonth
                                      showMonthDropdown
                                      showYearDropdown
                                      maxYear={10}
                                      dropdownMode="select"
                                    />

                                        <p style={{ color: "red" }}>
                                            {
                                                (this.state.errorBirth) ?
                                                "Birthday Field Can't Be Empty"
                                                :
                                                ""
                                            }
                                        </p>
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <InputLabel>Gender</InputLabel>
                                    <br />
                                    <FormControl fullWidth>
                                        <Select
                                            value={this.state.gender}
                                            onChange={(e) => this.handleChangeText("gender",e)}
                                            displayEmpty
                                            name="gender"
                                        >
                                        <MenuItem value={"male"}>male</MenuItem>
                                        <MenuItem value={"female"}>female</MenuItem>
                                        </Select>
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <CustomInput
                                        labelText="Description"
                                        id="headerText"

                                        inputProps={{
                                            value: this.state.description,
                                            onChange:(e) => this.handleChangeText("description",e)
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <CustomInput
                                        labelText="Job"
                                        id="headerText"

                                        inputProps={{
                                            value: this.state.job,
                                            onChange:(e) => this.handleChangeText("job",e)
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <CustomInput
                                        labelText="Company Code"
                                        id="headerText"

                                        inputProps={{
                                            value: this.state.company_code,
                                            onChange:(e) => this.handleChangeText("company_code",e)
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <InputLabel>User Level</InputLabel>
                                    <br />
                                    <FormControl fullWidth>
                                        <Select
                                            value={this.state.userlevel}
                                            onChange={(e) => this.handleChangeText("userlevel",e)}
                                            displayEmpty
                                        >
                                        <MenuItem value={0}>User</MenuItem>
                                        <MenuItem value={1}>Administrator</MenuItem>
                                        </Select>
                                    </FormControl>
                                </GridItem>
                            </GridContainer>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.handleClose("openAdd", false)} color="default">
                                Cancel
                            </Button>
                            <Button onClick={() => this.handleSubmit()}  color="primary">
                                Save
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog fullScreen open={this.state.openEdit} onClose={() => this.handleClose("openEdit", false)} aria-labelledby="form-dialog-title">
                        <DialogTitle id="form-dialog-title">Update User</DialogTitle>
                        <DialogContent>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={12}>
                                    <CustomInput
                                        labelText="Name"
                                        id="headerText"

                                        inputProps={{
                                            value: this.state.name,
                                            onChange:(e) => this.handleChangeText("name",e)
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <CustomInput
                                        labelText="Email"
                                        id="headerText"

                                        inputProps={{
                                            value: this.state.email,
                                            onChange:(e) => this.handleChangeText("email",e)
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <CustomInput
                                        labelText="Password"
                                        id="headerText"

                                        inputProps={{
                                            value: this.state.password,
                                            onChange:(e) => this.handleChangeText("password",e)
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <InputLabel>Birthday</InputLabel>
                                    <br />
                                    <FormControl fullWidth>

                                    <DatePicker
                                      dateFormat="yyyy-MM-dd"
                                      selected={moment(this.state.brithday).toDate()}
                                      onChange={date => this.handleChangedateNotif(date)}
                                      peekNextMonth
                                      showMonthDropdown
                                      showYearDropdown
                                      maxYear={10}
                                      dropdownMode="select"
                                    />
                                        <p style={{ color: "red" }}>
                                            {
                                                (this.state.errorBirth) ?
                                                "Birthday Field Can't Be Empty"
                                                :
                                                ""
                                            }
                                        </p>
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <InputLabel>Gender</InputLabel>
                                    <br />
                                    <FormControl fullWidth>
                                        <Select
                                            value={this.state.gender}
                                            onChange={(e) => this.handleChangeText("gender",e)}
                                            displayEmpty
                                            name="gender"
                                        >
                                        <MenuItem value={"male"}>male</MenuItem>
                                        <MenuItem value={"female"}>female</MenuItem>
                                        </Select>
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <CustomInput
                                        labelText="Description"
                                        id="headerText"

                                        inputProps={{
                                            value: this.state.description,
                                            onChange:(e) => this.handleChangeText("description",e)
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <CustomInput
                                        labelText="Job"
                                        id="headerText"

                                        inputProps={{
                                            value: this.state.job,
                                            onChange:(e) => this.handleChangeText("job",e)
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <CustomInput
                                        labelText="Company Code"
                                        id="headerText"

                                        inputProps={{
                                            value: this.state.company_code,
                                            onChange:(e) => this.handleChangeText("company_code",e)
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <InputLabel>User Level</InputLabel>
                                    <br />
                                    <FormControl fullWidth>
                                        <Select
                                            value={this.state.userlevel}
                                            onChange={(e) => this.handleChangeText("userlevel",e)}
                                            displayEmpty
                                        >
                                        <MenuItem value={0}>User</MenuItem>
                                        <MenuItem value={1}>Administrator</MenuItem>
                                        </Select>
                                    </FormControl>
                                </GridItem>
                            </GridContainer>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.handleClose("openEdit", false)} color="default">
                                Cancel
                            </Button>
                            <Button onClick={() => this.handleUpdate()}  color="primary">
                                Save
                            </Button>
                        </DialogActions>
                    </Dialog>
                </GridItem>
            </GridContainer>
        );
    }

}

function mapStateToProps(state) {
  return {
    blocking: state.loader
  };
}

export default withRouter(connect(
  mapStateToProps,
  // eslint-disable-next-line no-undef
  { pushLoader }
)(People));
